<div class="dropdown-control d-flex justify-center align-items-center clickable" [ngClass]="{ 'no-events': disableClick }" (click)="toggle()">

  <div class="display-container d-flex justify-center new-sidebar-icon">
    <span class="notification-icon-sidebar d-flex is-closed" [class.isDropdownOpen]="isDropdownOpen">
      <i phx-icon [phxIcon]="bellIcon"></i>
    </span>
    <phx-badge
      class="counter fz-10 lh-12"
      phxSize="small" [ngClass]="isDropdownOpen || isLoading || (notificationsSubject | async | unseenNotificationsCount) === 0 ? 'd-none' : 'd-flex'"
      [phxCount]="(notificationsSubject | async | unseenNotificationsCount) > 99 ? '99+' : notificationsSubject | async | unseenNotificationsCount">
    </phx-badge>
  </div>
</div>
<div class="content dropdown d-flex flex-col" [ngClass]="{ 'is-open': isDropdownOpen, 'collapsed-sidebar': isSideBarCollapsed }">
  <div class="header d-flex justify-center flex-col">
    <div class="d-flex justify-space-around align-items-baseline">
      <h2 class="d-inline-block fz-18" i18n>Notifications</h2>
      <button nz-button nzType="link" [disabled]="isLoading" (click)="markAllAsRead()" i18n>
        Mark all as read
      </button>
    </div>
    <div class="d-flex justify-center filters">
      <nz-radio-group-stretcher>
        <nz-radio-group [(ngModel)]="filterValue" (ngModelChange)="filterChange($event)">
          <label *ngFor="let filter of filters" nz-radio-button [nzValue]="filter">{{ filter.text }}</label>
        </nz-radio-group>
      </nz-radio-group-stretcher>
    </div>
  </div>
  <div class="divider"></div>
  <div class="network-error justify-center align-items-center" [ngClass]="{ 'd-none': !showError, 'd-flex': showError }">
    <svg class="ml-10"   width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm0-1a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zm-.6-9.63c0-.238.062-.423.186-.555.123-.132.3-.198.532-.198.23 0 .41.068.534.203.126.135.188.318.188.55 0 .234-.061.415-.185.544-.124.128-.303.192-.537.192-.479 0-.718-.245-.718-.737zm-.4 2.017c.979-.453 2-.06 2 .925 0 .482-.143.836-.546 1.582l-.007.013c-.338.627-.447.718-.447 1.18 0 .463.646.627 1 .463v.463c-.979.453-2 .06-2-.925 0-.485.141-.834.553-1.595l.007-.013c.33-.612.44-.705.44-1.168 0-.462-.646-.626-1-.462v-.463z" fill="#757575"/></svg>
    <span class="flex-1 ml-10" i18n>Unable to fetch data</span>
    <button class="alert-button" nz-button (click)="onErrorClick()" i18n>Try again</button>
  </div>
  <div *ngIf="!isLoading && (notificationsSubject | async).length === 0" class="empty d-flex flex-col align-items-center justify-center h-100">
    <no-results [filterValue]="filterValue"></no-results>
  </div>
  <div #notificationList *ngIf="(notificationsSubject | async).length > 0" class="notification-list" infiniteScroll [loadUntilOverflowEnabled]="true" (onScrollLimit)="onScrollToBottom()">
    <div *ngFor="let notification of notificationsSubject | async">
      <notification-item [notification]="notification" [loading]="isLoading" [hidePriority]="filterValue.hidePriority" (notificationClicked)="closeIfOpen()"></notification-item>
      <div class="divider"></div>
    </div>
  </div>
</div>
